/**
 * Small tribes list at the profile
 */
.profile-memberships-list {
  list-style: none;
  display: block;
  margin: 0;
  padding: 0;
}
